import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "networkTree" }
const _hoisted_2 = {
  key: 0,
  class: "leavesContainer"
}
const _hoisted_3 = {
  key: 1,
  class: "networkEmpty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_network_user = _resolveComponent("network-user")!
  const _component_network_tree = _resolveComponent("network-tree", true)!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_network_user, {
        class: _normalizeClass({ selected: _ctx.isOpen }),
        canWa: _ctx.canWa,
        item: _ctx.rootItem,
        onClick: _ctx.load
      }, null, 8, ["class", "canWa", "item", "onClick"])
    ]),
    (_ctx.isOpen && _ctx.firstLine)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.firstLine.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstLine, (item, i) => {
                  return (_openBlock(), _createBlock(_component_network_tree, {
                    rootItem: item,
                    key: item.identifier
                  }, null, 8, ["rootItem"]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstLine, (item, i) => {
                  return (_openBlock(), _createBlock(_component_network_tree, {
                    rootItem: item,
                    key: item.identifier
                  }, null, 8, ["rootItem"]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstLine, (item, i) => {
                  return (_openBlock(), _createBlock(_component_network_tree, {
                    rootItem: item,
                    key: item.identifier
                  }, null, 8, ["rootItem"]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstLine, (item, i) => {
                  return (_openBlock(), _createBlock(_component_network_tree, {
                    rootItem: item,
                    key: item.identifier
                  }, null, 8, ["rootItem"]))
                }), 128))
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Nessun utente in rete",
                  text: "Nessun utente in rete"
                })
              ]))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}